import { CompoundInterestsSimulatorSection } from '@/components/CompoundInterestsSimulator/CompoundInterestsSimulatorSection';
import {
  SeoTextWithNavigationEntry
} from '@/components/Seo/SeoTextWithNavigation';
import { ComplianceDisclaimer } from '@/components/simulators/ComplianceDisclaimer';
import { SimulatorLayout } from '@/components/simulators/SimulatorLayout';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';

const CompoundInterestsSimulatorPage = () => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  const seoEntries: SeoTextWithNavigationEntry[] = [
    {
      id: 'how-it-works',
      title: formatMessage({ id: `compound_interests_simulator.content.block1.title` }),
      text: formatMessage({ id: `compound_interests_simulator.content.block1.text` }),
    },
    {
      id: 'understand-simulator-resuts',
      title: formatMessage({ id: `compound_interests_simulator.content.block2.title` }),
      text: formatMessage({ id: `compound_interests_simulator.content.block2.text` }),
    },
    {
      id: 'get-to-financial-independence',
      title: formatMessage({ id: `compound_interests_simulator.content.block3.title` }),
      text: formatMessage({ id: `compound_interests_simulator.content.block3.text` }),
    },
  ];

  return (
    <SimulatorLayout title={formatMessage({ id: 'compound_interests_simulator.title' })} subtitle={formatMessage({ id: 'compound_interests_simulator.subtitle' })} seoEntries={seoEntries} disclaimer={<ComplianceDisclaimer />}>
      <NextSeo
        title={formatMessage({ id: 'compound_interests_simulator.meta.title' })}
        description={formatMessage({ id: 'compound_interests_simulator.meta.description' })}
        canonical={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}/${router.locale}/tools/compound-interests-calculator`}
        openGraph={{
          type: 'website',
          url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/${router.asPath}/`,
          title: formatMessage({ id: 'compound_interests_simulator.meta.title' }),
          description: formatMessage({ id: 'compound_interests_simulator.meta.description' }),
          images: [
            {
              url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/img/compound-interests-calculator/og_${router.locale}.png`,
              alt: formatMessage({ id: 'homepage.meta.preview' }),
            },
          ],
        }}
      />
      <Head>
        <meta
          name="twitter:title"
          content={formatMessage({ id: 'compound_interests_simulator.meta.title' })}
          />
        <meta
          name="twitter:description"
          content={formatMessage({ id: 'compound_interests_simulator.meta.description' })}
          />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}/img/compound-interests-calculator/og_${router.locale}.png`}
          />
      </Head>
      <CompoundInterestsSimulatorSection />
    </SimulatorLayout>
  );
};

export default CompoundInterestsSimulatorPage;
